import axios from "axios";
import { useEffect, useState } from "react";
import { AntOutline, RightOutline } from "antd-mobile-icons";
import {
  Button,
  InfiniteScroll,
  List,
  DotLoading,
  SearchBar,
  Card,
  Toast,
  Tag,
  TextArea,
  Dialog,
} from "antd-mobile";
import "./index.scss";

const colorDefault = [
  "red",
  "volcano",
  "orange",
  "gold",
  "lime",
  "green",
  "cyan",
  "blue",
  "geekblue",
  "purple",
];
const createBackgroundImage = (ind = 0) => {
  const arr = [
    "#6c97dc24,#0068ff2e",
    "#a5d83524, #2aca452e",
    "#e2cc2424, #c4c85d2e",
    "#ed687a24, #ea26512e",
    "#07285d24, #ce5fec2e",
    "#e36e1424, #dc5b052e",
    "#64d6ed7b, #a3ebff71",
    "#7c9f7824, #00fba36d",
  ];
  return `linear-gradient(to bottom, ${arr[ind % 8]})`;
};

const ExamList = () => {
  const [data, setData] = useState<string[]>([]);
  const [param, setParams] = useState<any>({
    page_num: 1,
    page_size: 10,
    type: "",
  });
  const [hasMore, setHasMore] = useState(true);
  async function loadMore() {
    const { list, page_num, page_size, total } = await getList({
      page_num: Number(param.page_num || 0) + 1,
      type: param.type,
    });
    setParams({ ...param, page_num: Number(page_num) });
    setData((val) => [...val, ...list]);
    if (
      total <= Number(page_size) ||
      !total ||
      Math.floor(total / Number(page_size)) <= Number(page_num)
    ) {
      setHasMore(false);
    } else {
      setHasMore(true);
    }
  }

  function doSearch() {
    setData([]);
    setHasMore(true);
    console.log(param.type,'param.type');
    
    getList({type:param.type}).then((res) => {
        const { list, page_num, page_size, total } = res;
        setData(list);
        if (
          total <= Number(page_size) ||
          !total ||
          Math.floor(total / Number(page_size)) <= Number(page_num)
        ) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
      });
  }

  const getList = (params = {}) => {
    return axios
      .get("/api/interview/list", {
        params: {
          page_num: 1,
          page_size: 10,
          ...params,
        },
        baseURL: process.env.NODE_ENV !== "development"  ? 'http://47.94.11.121:3337': ''
      })
      .then((res) => {
        return res.data.data;
      });
  };
  const onSearch=(val:any)=>{
    setParams({...param,type:val})
  }
  useEffect(() => {
    getList().then((res) => {
      const { list, page_num, page_size, total } = res;
      setData(list);
      if (
        total <= Number(page_size) ||
        !total ||
        Math.floor(total / Number(page_size)) <= Number(page_num)
      ) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }
    });
  }, []);
  return (
    <>
      <div className="header">
        <div className="left">
          <SearchBar onChange={onSearch} />
        </div>
        <div className="right">
          <Button size="small" color="primary" onClick={doSearch}>
            搜索
          </Button>
        </div>
      </div>
      {data.length > 0 ? (
        <>
          <List>
            {data.map((item, index) => (
              <List.Item key={index}>
                <Card
                  title={
                    <div style={{ textAlign: "center", width: "85vw" }}>
                      {item.type
                        ?.replace(/\，/g, ",")
                        ?.split(",")
                        ?.map((type: string, ind_: number) => {
                          return (
                            <Tag
                              key={index}
                              color={colorDefault[index % 10]}
                              style={{ marginLeft: 10, fontSize: 16 }}
                            >
                              {type}
                            </Tag>
                          );
                        })}
                    </div>
                  }
                  //   onBodyClick={onBodyClick}
                  //   onHeaderClick={onHeaderClick}
                  style={{
                    borderRadius: "16px",
                    backgroundImage: createBackgroundImage(index),
                  }}
                >
                  <div>{item.content.replace(/\s/g, "").slice(0, 100)}</div>
                  <TextArea
                    placeholder={item.answer}
                    autoSize={{ minRows: 3, maxRows: 8 }}
                  />
                  <div
                    style={{ textAlign: "right" }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Tag
                      color="primary"
                      style={{ fontSize: 16 }}
                      onClick={() => {
                        Dialog.alert({
                          title: "试题预览",
                          bodyStyle: { width: "90vw", marginLeft: "-7.5vw" },
                          content: (
                            <div
                              style={{
                                overflowX: "auto",
                                background: "black",
                                color: "white",
                                minHeight:'30vh'
                              }}
                            >
                              <pre>
                                <code>{item.answer}</code>
                              </pre>
                            </div>
                          ),
                        });
                      }}
                    >
                      查看
                    </Tag>
                  </div>
                </Card>
              </List.Item>
            ))}
          </List>
          <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
        </>
      ) : (
        <div className="placeholder">
          <div className="loadingWrapper">
            <DotLoading />
          </div>
          正在拼命加载数据
        </div>
      )}
    </>
  );
};
export default ExamList;
